import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * MetaData component for managing page metadata
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {string} props.description - Meta description
 * @param {string} props.ogUrl - Open Graph URL
 * @param {string} props.ogImage - Open Graph image path
 * @param {string} props.siteName - Site name
 */
function MetaData({
  title = "Сватбена покана",
  description = "Дигитална сватбена покана | Сватбен сайт",
  ogUrl = "",
  ogImage = "https://svatbena-pokana.com/wedding-invitation.jpg",
  siteName = "",
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {ogUrl && <meta property="og:url" content={ogUrl} />}
      <meta property="og:image" content={ogImage} />
      {siteName && <meta property="og:site_name" content={siteName} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image"/>
      <meta name="twitter:title" content={title}/>
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage}/>
    </Helmet>
  );
}

export default MetaData; 